import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { Goals } from '../../../models/dashboard/goals/goal';

const getGoalList = (searchValue: string, page:number, pageSize:number,orderDescending: boolean, userId:string,  deletedGoals:boolean, sortColumn: string ): Promise<Goals> => {
    return adminHttpClient.get(`/api/Admin/AdminGoals/get-goals?SearchValue=${searchValue}&PageNumber=${page}&PageSize=${pageSize}&OrderDescending=${orderDescending}&userId=${userId}&DeletedGoals=${deletedGoals}&SortColumn=${sortColumn}`)
}
export default getGoalList;